import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { getPageLabel } from 'lib/pages';
import GlobalMessage from './GlobalMessage';
import message from './message';

const blackListedPageLabels = ['QSS Print View Page'];

const mapStateToProps = () => ({
  type: 'error',
  message: message,
  show: !isEmpty(message) && !blackListedPageLabels.includes(getPageLabel()),
});

export default connect(mapStateToProps)(GlobalMessage);
